import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Link } from "react-router";
import ReactGA from "react-ga";
import _ from "lodash";
import { getCurrentPage } from "../helpers";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import PDFDownload from "./PDFDownload";
import FileDownload from "./FileDownload";

class RouteItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			hoveredOn: false,
		};

		this.focusOnPolyline = this.focusOnPolyline.bind(this);
		this.focusOffPolyline = this.focusOffPolyline.bind(this);
	}

	trackRouteItemClick = (query) => {
		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: "Show RouteItem - Sidebar",
			label: query,
		});
	};

	trackMoreInfoClick = (query) => {
		// GA Track
		ReactGA.event({
			category: _.startCase(getCurrentPage()),
			action: "Click RouteItem More Info Link",
		});
	};

	focusOnPolyline(e) {
		// Hide all but focused polylines.
		const polylines = this.props.initPolyLines;
		const hoveredName = this.props.route.name;
		polylines.forEach((item) => {
			item.opacity = 0.2;
			item.color = "#333333";

			if (item.rideName === hoveredName) {
				item.color = "#013852";
				item.opacity = 0.9;
			}
		});

		this.props.hidePolylines(polylines);
	}

	focusOffPolyline() {
		let polylines = this.props.initPolyLines;

		if (this.props.singleRoute) {
			polylines = polylines.filter((item) => {
				item.color = "#013852";
				item.opacity = 0.9;
				return item.rideName === this.props.singleRoute;
			});
		} else {
			polylines.forEach((item) => {
				item.color = "#013852";
				item.opacity = 0.9;
			});
		}
		this.props.hidePolylines(polylines);
	}

	render() {
		let query;
		const { route, area } = this.props;

		let region = route.region ? route.region.split(",")[0] : "";
		// Horrible but we have two representations of BANES at the moment
		region = region.replace(
			"Bath and North East Somerset",
			"bath & ne somerset"
		);
		const routeDisplay = route.region.split(",").slice(0, 2).sort().join(" | ");

		route.name
			? (query = encodeURI(route.name.replace("/", "_")))
			: (query = "");

		return (
			<li>
				<CSSTransitionGroup
					transitionName="fade-in"
					transitionAppear={ true }
					transitionAppearTimeout={ 400 }
					transitionEnterTimeout={ 400 }
					transitionLeaveTimeout={ 400 }
				>
					{ route.name && !this.props.singleRoute && (
						<Link
							to={ `/cycle-routes/${ area }/${ region }/${ query }` }
							className="cycling-route__list-item"
							onMouseEnter={ this.focusOnPolyline }
							onMouseLeave={ this.focusOffPolyline }
							onClick={ (e) => this.trackRouteItemClick(route.name) }
						>
							<span
								className="cycling-route__list-item__border"
								aria-hidden="true"
								style={ { backgroundColor: `#${ this.props.route.color }` } }
							></span>
							<span
								className="cycling-route__list-item__border-bottom"
								aria-hidden="true"
								style={ { backgroundColor: `#${ this.props.route.color }` } }
							></span>
							<small
								className="cycling-route__list__ncn"
								aria-hidden={ !!route.ncn }
								style={ { backgroundColor: `#${ this.props.route.color }` } }
							>
								{ route.ncn }
							</small>
							<img
								className="cycling-route__list__image"
								src={ route.image ? route.image : "/images/cycling.jpg" }
								alt={ `A section of the ${ route.name } cycle route` }
								style={ { borderColor: `#${ this.props.route.color }` } }
							/>

							<div className="cycling-route__list__text">
								<div>
									<h3 className="cycling-route__list__title">
										{ route.name || "Unnamed Route" }
									</h3>
								</div>

								<svg className="cycling-route__list__arrow">
									<use xlinkHref="#right-arrow-go" />
								</svg>
							</div>
						</Link>
					) }

					{ this.props.singleRoute && (
						<div>
							<h1 className="signpost-title">
								<span
									className="signpost-colour"
									style={ { backgroundColor: `#${ route.color }` } }
								>
									{ route.ncn ? (
										route.ncn
									) : (
										<svg>
											<use xlinkHref="#bike-rentals" />
										</svg>
									) }
								</span>
								{ route.name }
							</h1>
							<h2 className="signpost">
								<span className="signpost-name">{ routeDisplay }</span>
							</h2>
							<p className="description">{ route.description }</p>

							<img
								className="single-route-image"
								src={ route.image ? route.image : "/images/cycling.jpg" }
								alt={ `A section of the ${ route.name } cycle route` }
							/>

							{ route.video && (
								<div className="single-route-video" aria-hidden="true">
									<iframe
										className="single-route-video__iframe"
										width="420"
										height="315"
										src={ route.video }
										allowFullScreen
									></iframe>
								</div>
							) }

							<div className="rides-list">
								<div className="ride-item-info">
									<div className="ride-item-download">
										<PDFDownload
											url={ route.pdf }
											fileSize={ route.pdf_file_size }
											text="View Maps & Guides"
											isDownload={ false }
										/>
										<FileDownload
											url={ route.kml }
											fileType="KML"
											description="KML is a file format used to display geographic data in an Earth browser such as Google Earth"
											xlinkHref="#kml"
											fileSize={ route.kml_file_size }
										/>
										<FileDownload
											url={ route.gpx }
											fileType="GPX"
											description="GPX is a GPS data format for software applications used to describe waypoints, tracks and routes."
											xlinkHref="#pin"
											fileSize={ route.gpx_file_size }
										/>
									</div>
								</div>
							</div>
						</div>
					) }
				</CSSTransitionGroup>
			</li>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		initPolyLines: state.map.polylines.poly,
	};
};

export default connect(mapStateToProps)(RouteItem);

RouteItem.contextTypes = {
	router: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/RouteItem.js